module.exports = __webpack_public_path__ + "static/img/aws-cci-3.71b7bcd1.png";